import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEmbed = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.33203 4L1.33203 8L5.33203 12M10.6654 4L14.6654 8L10.6654 12",
		stroke: "#EFEEF0",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgEmbed;
